<div class='background'>
  @if (displayCells.length) {
    <div class="counter" [style.background-color]="backgroundColor" [style.height]="height">
      @for (cell of displayCells; track $index) {
        <div class="number" [class.has-decimal]="cell.decimalAfter" [style.width]="width">
          <div class="number-box">
            <div class="top border" [style.border-top-color]="cell.char.match(reg1) ? disabledColor: activeColor"></div>
            <div class="left border" [style.border-left-color]="cell.char.match(reg2) ? disabledColor: activeColor"></div>
            <div class="right border" [style.border-right-color]="cell.char.match(reg3) ? disabledColor: activeColor"></div>
            <div class="bottom border center" [style.border-bottom-color]="cell.char.match(reg4) ? disabledColor: activeColor"></div>
          </div>
          <div class="number-box">
            <div class="top border center" [style.border-top-color]="cell.char.match(reg4) ? disabledColor: activeColor"></div>
            <div class="left border" [style.border-left-color]="cell.char.match(reg5) ? disabledColor: activeColor"></div>
            <div class="right border" [style.border-right-color]="cell.char.match(reg6) ? disabledColor: activeColor"></div>
            <div class="bottom border" [style.border-bottom-color]="cell.char.match(reg7) ? disabledColor: activeColor"></div>
          </div>
          @if (cell.decimalAfter) {
            <span class="decimal-separator" [style.color]="activeColor">,</span>
          }
        </div>
      }
    </div>
  }
</div>
<div class='info'>Kg</div>
